import avatar from '@/assets/images/user.png'

// 訂單狀態
const orderStatusLookup = {
  0: '找司機' /* 之前叫 待派單 */,
  1: '待載客',
  2: '載客中',
  3: '待驗單',
  4: '完成',
  5: '取消',
  6: '全部',
}

// 派遣方式
const deliveryMethodLookup = {
  0: '就醫接送',
  1: '社區式接送',
  2: '社區式接送(共乘)',
}

// 服務項目
const serviceLookup = {
  wheelchair: '一般輪椅',
  highBackWheelchair: '高背輪椅',
  suv: '休旅車',
}

// 補助方式
const subsidyMethodLookup = {
  0: '就醫接送',
  1: '社區式接送',
  2: '使用博愛卡',
  3: '自費',
}

// 驗證方式
const verificationMethodLookup = {
  0: '乘客簽名',
  1: '掃描 QR code',
  2: '驗證號碼',
  3: '不使用補助',
}

// 地區類型
const areaTypeLookup = {
  0: '一般地區',
  1: '次偏鄉地區',
  2: '偏鄉地區',
}

// 收入等級
const userClassLookup = {
  0: '一般收入戶',
  1: '中低收入戶',
  2: '低收入戶',
}

const generateOptions = (_lookup) =>
  Object.keys(_lookup).map((val) => ({
    value: val,
    label: _lookup[val],
  }))

export const defaultOption = {
  avatar,
  orderStatusLookup,
  orderStatusOptions: generateOptions(orderStatusLookup),
  deliveryMethodLookup,
  deliveryMethodOptions: generateOptions(deliveryMethodLookup),
  serviceLookup,
  serviceOptions: generateOptions(serviceLookup),
  subsidyMethodLookup,
  subsidyMethodOptions: generateOptions(subsidyMethodLookup),
  verificationMethodLookup,
  verificationMethodOptions: generateOptions(verificationMethodLookup),
  areaTypeLookup,
  areaTypeOptions: generateOptions(areaTypeLookup),
  userClassLookup,
  userClassOptions: generateOptions(userClassLookup),
  perPageOptions: [25, 50, 100].map((val) => ({
    value: Number(val),
    label: val,
  })),
  userForm: {
    rules: {
      name: [{ required: true, message: '姓名必填', trigger: 'blur' }],
      areaType: [
        { required: true, message: '區域類型必填', trigger: 'change' },
      ],
      class: [{ required: true, message: '身份別必填', trigger: 'change' }],
      firstMobilePhoneNumber: [
        { required: true, message: '手機一必填', trigger: 'blur' },
      ],
      area: [{ required: true, message: '行政區必填', trigger: 'change' }],
      address: [{ required: true, message: '住家地址必填', trigger: 'blur' }],
    },
  },
  longTermCareUser: {
    name: '王大名',
    areaType: 1,
    class: 2,
    firstMobilePhoneNumber: '0912345678',
    contactPerson: '王大明',
    secondMobilePhoneNumber: '0912345678',
    communityShuttleFrequency: 1,
    telephoneNumber: '33123456',
    identityCode: '123',
    area: '旗津區',
    address: '貓咪',
    photo: null,
  },
}



// WEBPACK FOOTER //
// ./src/pages/longTermCare/defaultOption.js